import Client from "./base/client";

export class CheckoutPayment {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  private resourceUrl = "/api/v2/checkout";

  fetchDetail = <TData extends object>({
    form_id,
    registration,
  }: {
    form_id: string;
    registration: string;
  }): Promise<TData> => {
    const formData = new FormData();
    formData.append("form_id", form_id);
    formData.append("registration", registration);

    return this.client.post(`${this.resourceUrl}/detail`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  completeCheckoutPayment = <TData extends object>(
    data: any
  ): Promise<TData> => {
    return this.client.post(`${this.resourceUrl}/complete`, data);
  };
}
